import { EventRegistrationPageSkeleton } from "./EventRegistrationPageSkeleton";
import { EmptyState } from "../../../../layout/EmptyState";
import { Closed, Early } from "../../../../../styleguide/icons/icons";
import { useEvent } from "../EventProvider";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import { EventRegistrationWrapper } from "./EventRegistrationWrapper";
import { RegistrationPageHeader } from "../../../../layout/registration/RegistrationPageHeader";
import { CloudOff } from "@mui/icons-material";
import { T } from "components/util/t";
import { useCanAcceptPayments } from "hooks/useCanAcceptPayments";
import { useMeta } from "hooks/useMeta";
import dayjs from "dayjs";
import { SHORT_DATE } from "utils/dates";
import { useLocalizationContext } from "components/providers/LocalizationProvider";
import { getEventMetadataDescription } from "utils/metadata";

const EventRegistration = ({ event }) => {
    const { translate } = useLocalizationContext();
    const canAcceptPayments = useCanAcceptPayments(event.paymentOptions, event.organisation.shortName);

    const eventDate = dayjs(event.date).format(SHORT_DATE);
    const translationProps = {
        eventName: event.name,
        sportType: translate(event.organisation.sportType),
        eventDate: eventDate,
        eventLocation: event.location?.placePredictionText,
        orgName: event.organisation.name,
    };
    
    useMeta({
        title: "event_rego_meta_title",
        description: getEventMetadataDescription(translationProps),
        translationProps
    });

    return (
        <>
            <RegistrationPageHeader
                crumbs={[
                    { text: event.organisation.name, link: `/${event.organisation.shortName}` },
                    { text: event.name, link: `/events/${event.id}` },
                ]}
                title="Event registration"
            />
            {canAcceptPayments
                ? event.status === "upcoming" ?
                    <EventRegistrationWrapper event={event}/> :
                    <EmptyState
                        icon={event.status === "scheduled" ? <Early/> : <Closed/>}
                        text={event.status === "scheduled" ?
                            "You're a little early! Registration is not open yet - check back soon." :
                            "You're a little late! Registration has been closed by the organiser."
                        }
                        action={
                            <Button variant="contained" component={Link} to={`/${event.organisation.shortName}`}>
                                {event.organisation.name}
                            </Button>
                        }
                    />
                : <EmptyState icon={<CloudOff />} text={<T organisation={event.organisation}>registration_unavailable</T>} />}
        </>
    );
};

const EventRegistrationPage = () => {
    const event = useEvent();

    if (!event) return <EventRegistrationPageSkeleton/>;

    return <EventRegistration event={event}/>;
};

export default EventRegistrationPage;
